var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTransactionReportScheduler = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.489258 10.0005C0.489258 5.58634 0.489258 3.37929 1.86055 2.00801C3.23183 0.636719 5.43888 0.636719 9.853 0.636719C14.2671 0.636719 16.4742 0.636719 17.8454 2.00801C19.2167 3.37929 19.2167 5.58634 19.2167 10.0005C19.2167 14.4145 19.2167 16.6217 17.8454 17.9929C16.4742 19.3642 14.2671 19.3642 9.853 19.3642C5.43888 19.3642 3.23183 19.3642 1.86055 17.9929C0.489258 16.6217 0.489258 14.4145 0.489258 10.0005Z",
    fill: "#807EEC",
    stroke: "#807EEC",
    strokeWidth: 0.585234
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8485 14.741H4.97313C4.83528 14.7405 4.7031 14.686 4.60484 14.5894C4.50657 14.4927 4.45002 14.3614 4.44727 14.2236V5.80126C4.44727 5.66179 4.50267 5.52803 4.60129 5.42941C4.69991 5.33079 4.83366 5.27539 4.97313 5.27539H13.387C13.5265 5.27539 13.6602 5.33079 13.7588 5.42941C13.8575 5.52803 13.9129 5.66179 13.9129 5.80126V10.5319",
    stroke: "white",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44727 7.59961H13.9129",
    stroke: "white",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58301 5.65166V4.5957",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6426 5.65166V4.5957",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6564 15.4641C14.1062 15.4641 15.2815 14.2888 15.2815 12.839C15.2815 11.3892 14.1062 10.2139 12.6564 10.2139C11.2066 10.2139 10.0312 11.3892 10.0312 12.839C10.0312 14.2888 11.2066 15.4641 12.6564 15.4641Z",
    stroke: "white",
    strokeWidth: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4932 11.502V12.876L13.2441 13.3792",
    stroke: "white",
    strokeWidth: 0.675,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionReportScheduler, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TransactionReportScheduler.f8331b70.svg";
export { ForwardRef as ReactComponent };